<mat-card class="width-gt-xs" data-cy="WintertrainingPage" role="article">
    <mat-card-header role="heading">
        <mat-card-title>Wintertraining</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <p>
            In der Wintersaison zwischen November und Ende März paddeln nur einige Unentwegte. Die sportlichen
            Aktivitäten verlagern sich nach drinnen:
        </p>
        <p>
            Mittwochs besteht die Möglichkeit zum Kraftausdauertraining in der Turnhalle des FEG Mühlheim.
            Das Training ist ein Gemeinschaftsangebot des benachbarten MRV, des RC-Adler und des KKM. Schwerpunkt liegt
            auf der Kräftigung der Rumpfmuskulatur – das A und O für effizienten und gesunden Paddelsport.
        </p>
        <p>
            Konkurrierend dazu treffen wir uns zum Kenterrollentraining im Hallenbad. Wir haben die Möglichkeit,
            Mittwochs das Schwimmbad des Landessportbundes in Frankfurt gemeinsam mit anderen Vereinen der Region zu
            nutzen. Das Rollentraining bedarf der Voranmeldung und wird über eine Chat-Gruppe organisiert.
        </p>
    </mat-card-content>
</mat-card>
